<template>
    <div class="warp">
      <!-- 面包屑 -->
      <breadcrumb :back="true" :crubList="[{name:'审核管理'},{name:'债权融资需求发布审核',goback:true},{name:'债权融资需求发布审核详情'}]" :title="'债权融资需求发布审核详情'"/>
      <!-- 主体内容 -->
      <!-- 用户明细 -->
      <div class="box">
        <el-card class="basic box_card" header="账号信息" shadow="never">
          <el-row>
            <el-col :span="8">
              <div class="child">
                <div class="name">发布账号：</div>
                <div class="content">{{ checkDetails.userName }}</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="child">
                <div class="name">账号类型：</div>
                <div class="content">{{ checkDetails.userTypeName }}</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="child">
                <div class="name">姓名：</div>
                <div class="content">{{ checkDetails.realName }}</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="child">
                <div class="name">邮箱：</div>
                <div class="content">{{ checkDetails.email }}</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="child">
                <div class="name">联系地址：</div>
                <div class="content">{{ checkDetails.contactAddress }}</div>
              </div>
            </el-col>
          </el-row>
        </el-card>
        <el-card
          class="basic box_card mt16"
          header="企业债权融资需求详情"
          shadow="never"
        >
          <el-row>
            <el-col :span="8">
              <div class="child">
                <div class="name">开户银行：</div>
                <div class="content">
                  {{ checkDetails.bankName || '--' }}
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="child">
                <div class="name">企业全称：</div>
                <div class="content">
                  {{ checkDetails.companyName || '--' }}
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="child">
                <div class="name">行业：</div>
                <div class="content">
                  {{ checkDetails.industryStr || '--' }}
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="child">
                <div class="name">拟贷款金额（万元）：</div>
                <div class="content">
                  {{ checkDetails.proLoanAmount || '--' }}
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="child">
                <div class="name">企业员工数：</div>
                <div class="content">
                  {{ checkDetails.employNum || '--' }}
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="child">
                <div class="name">上年度营收：</div>
                <div class="content">
                  {{ checkDetails.lastYearBusinessIncomeStr || '--' }}
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="child">
                <div class="name">上年度纳税：</div>
                <div class="content">
                  {{ checkDetails.lastYearPayTaxesStr || '--' }}
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="attachment">
              <div class="name">附件：</div>
              <ul class="content">
                <li v-for="(item,index) in checkDetails.fileList" :key="index">
                  <span>{{item.fileName}}</span>
                  <i class="el-icon-download" @click="open(item)"></i>
                </li>
              </ul>
            </div>
            </el-col>
          </el-row>
        </el-card>
        <el-card
          class="basic box_card mt16"
          header="审核结果"
          shadow="never"
          v-if="tab === '2'"
        >
          <el-row>
            <el-col :span="8">
              <div class="child">
                <div class="name">审核结果：</div>
                <div class="content">{{checkDetails.checkStatusValue}}</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="child">
                <div class="name">审核账号：</div>
                <div class="content">{{checkDetails.auditAccount}}</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="child">
                <div class="name">审核时间：</div>
                <div class="content">{{checkDetails.updateTime}}</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="child">
                <div class="name">说明：</div>
                <div class="content">{{checkDetails.checkExplanation}}</div>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </div>
    </div>
</template>

<script>
import {onDownload} from "@/utils/common";
import breadcrumb from '../../components/breadcrumb';
export default {
  components: {
    breadcrumb
  },
  data() {
    return {
      tab: '1', //选项卡
      id: '', //详情id
      checkDetails: {
        auditAccount: '',
        bankName: '',
        checkExplanation: '',
        checkStatus: null,
        checkStatusValue: '',
        companyName: '',
        contactAddress: '',
        email: '',
        employNum: '',
        fileList: [],
        industry: null,
        industryValue: '',
        operateIncomePreYear: '',
        proLoanAmount: null,
        profitsPreYear: '',
        realName: '',
        updateTime: '',
        userName: '',
        userTypeName: '',
      }, //查看明细
      debtStatistics: '', //债权融资统计
      financialLeasingStatistics: '', //融资租赁统计
      equityStatistics: '', //股权融资列表统计
      vouchStatistics: '', //担保服务统计
      policyGuidanceStatistics: '', //政策指引统计
      incubatorStatistics: '', //孵化器统计
      activitySalonStatistics: '', //活动沙龙统计
      center: {}, //地图中心点
      maker: {}, //标记点
      zoom: 15, //缩放等级
    }
  },
  methods: {
    open({fileName,filePath}){
            const formData = new window.FormData()
          formData.append('fileName', filePath)
          onDownload(formData,fileName)
        },
    //获取数据
    async getData() {
      const { code, data, msg } = await this.$axiosc.get(
        'backstage/myDeptNeeds/logs/' + this.id,
      )
      if (code == 200) {
        this.checkDetails = data
      } else {
        this.$alert(msg)
      }
    },
  },
  created() {
    this.tab = this.$route.params.type
    this.id = this.$route.query.id
  },
  mounted() {
    this.getData()
  },
}
</script>

<style lang="scss" scoped>
.warp{
  height:100%;
  overflow: hidden;
}
.box{
  height: calc(100% - 40px);
    overflow-x: hidden;
    overflow-y: auto;
  // margin-top: 20px;
  &_card {
    border: none;
    &::v-deep {
      .el-card__header {
        font-size: 16px;
        color: #262626;
        padding: 14px 22px !important;
        border-bottom-color: #e5e5e5;
      }
      .el-card__body {
        padding: 24px 25px !important;
      }
    }
  }
}
.basic {
  color: $font;
  font-size: 14px;
  font-weight: 400;
  line-height: 40px;
  // background: #fff;
  .el-col {
    margin: 10px 0;
  }
  .child {
    color: #595959;
  }
}
.main {
  background: transparent !important;
  padding: 0 !important;
}
</style>
